import React from "react";
import _ from 'lodash';
import VoiceMailInnerTop from "./voiceMailInnerTop";
import VoiceMailBox from "../voiceMailInner/voiceMailInnerBox";
import { initialStateModel } from "../../../../models/model";
import { useSelector } from "react-redux";
import NoCalls from "../../leftsidebar/noCalls";
import VoiceMailNoData from "../../../../styles/images/empty_states/empty-voicemail.svg";
import { URvoicemailSkeleton } from "../../../../shared/skeletonLoading/voicemailSkeleton";
//import { callMainPageInterface } from "../../../../models/callModel";

export default function VoiceMailInner() {

  const {callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  let { isParticularLoading, particularLog} = callReducer;
  return (
    <>
      <div className="topBarvoice"><h3>Voicemail</h3></div>
          {!isParticularLoading ?
            (!_.isEmpty(particularLog)?<>
              <VoiceMailInnerTop />
              <VoiceMailBox />
              </> :
            <NoCalls voiceMailEmptySrc={VoiceMailNoData} />) :
        (<URvoicemailSkeleton />)}</>
  );
};
